module.exports = __webpack_public_path__ + "static/media/kiaraDawn.4ecdf72e.png";